import { createContext, useReducer } from 'react';
import { LOCALES } from "../../i18n"

const AppContext = createContext();

const defaultContext = {
    locale: LOCALES.FRENCH,
    chemin: {
        userId: "",
        cheminQuestion: [],
        cheminIndex: 0,
        strategyId: "",
        timeStart: "",
        timeEnd: "",
        didWork: false,
    }
}

const defaultChemin = {
    userId: "",
    cheminQuestion: [],
    cheminIndex: 0,
    strategyId: "",
    timeStart: "",
    timeEnd: "",
    didWork: false,
}

const reducer = (state, action) => {
    switch (action.type) {
        case "reset":
            return defaultContext;

        case "resetChemin":
            return {...state, chemin: defaultChemin}

        case "setLocale":
            return {...state, locale: action.locale}
        
        case "setChemin":
            return {...state, chemin: action.chemin}
        
        default:
            return defaultContext;
    }
}

const AppContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, defaultContext);
    const value = {state, dispatch};

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    )
}

export { AppContext, AppContextProvider}
